import { render, staticRenderFns } from "./AlertDialog.vue?vue&type=template&id=37d89b66&scoped=true"
import script from "./AlertDialog.vue?vue&type=script&lang=js"
export * from "./AlertDialog.vue?vue&type=script&lang=js"
import style0 from "./AlertDialog.vue?vue&type=style&index=0&id=37d89b66&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d89b66",
  null
  
)

export default component.exports